export default {
  title: "Localidad"
  , form: {
    codigo: {
      label: "Código"
      , th: "Código"
    }
    , nombre: {
      label: "Nombre"
      , th: "Nombre"
    }
    , provincia: {
      label: "Provincia"
      , th: "Provincia"
    }
    , codigopostal: {
      label: "Códigos Postales"
      , th: "Códigos Postales"
    }
  }
  , errors: {
    BD6001: { text: "Ocurrió un error en el catálogo de Localidad" }
    , WS6001: { text: "Ocurrió un error en el catálogo de Localidad" }
    , JS6001: { text: "Ocurrió un error en el catálogo de Localidad" }
    , CR6001: { text: "Ocurrió un error en el catálogo de Localidad" }
    , UK_Localidad: { text: "Ya existe un registro con el mismo nombre y asignada a la misma provincia" }
    , UK_Localidad_Codigo: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/geograficos/localidad.js